import { useLazyQuery } from '@provision/graphql-client';
import { gql } from 'src/gql';

const UserLiveTranscriptionQuery = gql(`
  query GetUserLiveTranscription($params: GetUserLiveTranscriptionInput!) {
    getUserLiveTranscription(params: $params) {
      transcriptionId
      externalTranscriptionId
      partnerId
      userId
      isFinished
      cursor
      segments {
        role
        timestamp
        transcriptionText
        start
        duration
      }
    }
  }
`);

export const useUserLiveTranscription = () =>
  useLazyQuery(UserLiveTranscriptionQuery, { fetchPolicy: 'no-cache' });
